import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from "@angular/router";
import { Store } from '@ngxs/store';
import { ModalActions } from '@web-bankir/shared/states/modal';

export function passwordRecoveryHashGuard(): CanActivateFn {
  return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const store: Store = inject(Store);
    const router: Router = inject(Router);

    if (route.queryParams['hash']) {
      setTimeout(() => {
        store.dispatch(new ModalActions.Open({
          route: ['password-recovery'],
          params: {
            hash: route.queryParams['hash']
          }
        }))
      })
    }

    return router.createUrlTree(['/authorization']);
  }
}
